import axios, { InternalAxiosRequestConfig } from "axios"
import { getAuthUserToken } from "infra/security/auth-user-token"
import { BASE_URL } from "global"


export const apiClient = axios.create({
})


const bearerTokenRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  const token = getAuthUserToken()

  const url = config.url

  if (BASE_URL && url && url.startsWith(BASE_URL)) {
    config.headers["Authorization"] = `Bearer ${token}`
  }
  return config
}

apiClient.interceptors.request.use(bearerTokenRequestInterceptor)


const tokenExpiredResponseProcessor = (error: any) => {

  let handled = false
  if (
    (error?.response?.status === 403 || error?.response?.status === 401) &&
    (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
  ) {
    localStorage.clear()
    window.location.href = "/login"
    handled = true
  }
  return handled
}

const errorHandler = (error: any) => {
  let handled = false
  handled ||= tokenExpiredResponseProcessor(error)

  if (!handled)
    return Promise.reject(error)
}

apiClient.interceptors.response.use(
  (response) => {
    return response
  }, errorHandler)
